/**
 * database states
 */
export const AAFDATABASE_CREATED = 'CREATED';
export const AAFDATABASE_DELETED = 'CLEARED';
export const AAFDATABASE_UPDATED = 'UPDATED';
export const AAFDATABASE_DELETING = 'CLEARING';
export const AAFDATABASE_UPDATING = 'UPDATING';
export const AAFDATABASE_OUTDATED = 'OUTDATED';
export const AAFDATABASE_ERROR = 'ERROR';
export const AAFDATABASE_INSERTING_ERROR = 'INSERTING_ERROR';

export const CHANNELS_DB_A = 'channelsDB_A';
export const CHANNELS_DB_B = 'channelsDB_B';

export const CHANNELS_DB_TABLE = 'channelsEvents';
export const CHANNELS_DB_CLONE_TABLE = `${CHANNELS_DB_TABLE}Clone`;
export const CHANNELS_DB_FIELDS =
  'id, event_alf_id, id_composite, group_id, date_begin, date_end, ext_eventimage_name, name, recording_status';

export const EVENTS_DB_TABLE = 'events';
export const EVENTS_DB_CLONE_TABLE = `${EVENTS_DB_TABLE}Clone`;
export const EVENTS_DB_FIELDS =
  'id, event_alf_id, id_composite, group_id, date_begin, date_end, channel_id, description, duration, ext_eventimage_name, ext_recordable, parental_rating, previousEventId, nextEventId, type, ext_startover, ext_year, dvb_content, ext_catchup, recording_status, recording_id, ext_series_id, ext_episode_id, ext_season_id';

export const DB_TABLES = [CHANNELS_DB_TABLE, EVENTS_DB_TABLE];
export const DB_FIELDS = [CHANNELS_DB_FIELDS, EVENTS_DB_FIELDS];



// WEBPACK FOOTER //
// ./src/AAFPersistenceManager/Constans.js